/**
 * Takes rgb hex and alpha and returns it eiter in rgba(r,g,b,a) {when alpha [0;1)} or #RRGGBB when {alpha==1}
 * @param {string} rgbHex rgb hex in form #RRGGBB
 * @param {Number} alpha alpha number in range [0;1]
 */
function PickerOutput(rgbHex, alpha) {
    if (!/^#[A-Fa-f0-9]{6}$/.test(rgbHex)) {
        throw new Error("Invalid hex");
    }
    if (typeof (alpha) === "undefined") {
        return rgbHex;
    }
    if (typeof (alpha) !== "number") {
        throw new Error("Alpha should be a number in a range [0;1]");
    }
    if (alpha < 0 || alpha > 1) {
        throw new Error(`Alpha should be a number in a range [0;1], instead got ${alpha} `);
    }
    if (alpha === 1) {
        return rgbHex;
    }
    const r = parseInt(rgbHex.slice(1, 3), 16);
    const g = parseInt(rgbHex.slice(3, 5), 16);
    const b = parseInt(rgbHex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${Math.round(alpha*100)/100})`
}

export default PickerOutput;